import { NavLink as ReactRouterNavLink, useLocation } from 'react-router-dom'
import {
  Box,
  Burger,
  Flex,
  Image,
  NavLink,
  useMantineTheme,
} from '@mantine/core'

import type { AppShellCollapsedProps } from '@/types/appShell.types'

import { NAVIGATION_BAR_CONFIG } from '@/layouts/AuthenticatedLayout/components/NavigationBar/NavigationBar.config'

import { useUserStore } from '@/store/user.store'

import { AdvisorWidget } from '@/components/AdvisorWidget/AdvisorWidget'

import { role } from '@/__generated__/requests'

import classes from './NavigationBar.module.css'

export function NavigationBar({ opened, toggle }: AppShellCollapsedProps) {
  const location = useLocation()
  const theme = useMantineTheme()
  const user = useUserStore.use.user()
  const currentRole = useUserStore.use.currentRole()

  if (!currentRole) {
    return null
  }

  const navItems = NAVIGATION_BAR_CONFIG.filter(
    item => item.role === currentRole,
  )

  return (
    <Flex className={classes.sidebar} p="md">
      <Box>
        <Flex align="center" justify="space-between">
          <Image alt="Rolan Wealth" maw={200} src="/logo_inverse.svg" />

          <Burger
            color={theme.other.colors.white}
            hiddenFrom="sm"
            onClick={toggle}
            opened={opened}
            size="md"
          />
        </Flex>

        <Box mt={24}>
          {navItems.map(item => {
            const isActive =
              location.pathname === item.to ||
              location.pathname.startsWith(`${item.to}/`)

            return (
              <NavLink
                key={item.label}
                active={isActive}
                classNames={{
                  label: classes.label,
                  root: `${classes.root} ${isActive ? classes.active : ''}`,
                  section: classes.section,
                }}
                component={ReactRouterNavLink}
                label={item.label}
                leftSection={<item.icon />}
                mb="xs"
                onClick={toggle}
                opacity={1}
                p="md"
                rightSection={false}
                to={item.to}
              />
            )
          })}
        </Box>
      </Box>

      {user?.roles?.includes(role.EMPLOYEE) && <AdvisorWidget />}
    </Flex>
  )
}
